module.exports = __webpack_public_path__ + "img/mini-finalized.2549f4b1.svg";